import { render, staticRenderFns } from "./EmployeesHeader.vue?vue&type=template&id=2f5fe289&scoped=true&"
import script from "./EmployeesHeader.vue?vue&type=script&lang=ts&"
export * from "./EmployeesHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeesHeader.vue?vue&type=style&index=0&id=2f5fe289&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5fe289",
  null
  
)

export default component.exports